import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";

import translate from "@insite/client-framework/Translate";

import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    multipleSaleQty?: string;
}

export interface MsqStyles {
    msqContainer: InjectableCss;
}

export const msqStyles: MsqStyles = {
    msqContainer: {
        css: css``,
    },
};

const Msq: FC<OwnProps> = ({ multipleSaleQty }) => {
    return (
        <>
            <StyledWrapper {...msqStyles.msqContainer}>
                {multipleSaleQty && Number(multipleSaleQty) > 1 ? (
                    <Typography style={{ display: "block" }}>
                        {translate("Multiple Sale Qty {0}", multipleSaleQty.toString())}
                    </Typography>
                ) : (
                    ""
                )}
            </StyledWrapper>
        </>
    );
};
export default Msq;
